<template>
<div>
    <van-uploader
    @click-preview="showPreview"
    :accept="item.accept"
    :after-read="afterRead"
    :max-count="item.max"
    v-model="copyUpLoader"
    :upload-icon="item.icon || 'photograph'"
    :upload-text="item.upName || '添加图片'"
    :before-read="asyncBeforRead"
  >
  <!-- <template #preview-cover="{ file }">
    <div class="preview-cover van-ellipsis">{{ file.name }}111</div>
  </template> -->
 
    <template
      #preview-cover="{ file }"
    >
      <div class="preview-cover" v-if="file && file.type.indexOf('video') > -1"><img :src="play" class="coverImg" /></div>
    </template>
    <!-- <template
      v-if="videoUrl"
      slot="preview-cover"
    >
      <div class="preview-cover"><img :src="play" class="coverImg" /></div>
    </template> -->
    
  </van-uploader>
  <!-- 视频播放 -->
  <van-overlay :show="showvideoplay">
    <div class="video-warp">
      <div class="content">
        <video
          controls
          controlslist="nodownload  noremoteplayback"
          :disablePictureInPicture="true"
          style="width: 100%; height: 100%; object-fit: contain"
          :src="videoUrl"
          ref="video"
        ></video>
        <div class="close" @click="stopVideo">
          <img src="@/assets/appeal/close.png" width="32" alt="">
        </div>
      </div>
    </div>
  </van-overlay>
</div>
</template>
<script>
  // import { uploadFileOss } from "@/api/oss";
 //文件上传前校验
export default {
  model: {
    prop: "upLoader",
    event: "change",
  },
  props: {
    upLoader:{
      type:Array,
      default: () => [],
    },
    item: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    copyUpLoader: {
      get() {
        return this.upLoader
      },
      set(val) {
        this.$emit("change", val);
      }
    }
  },

  data () {
    return {
      play:require("@/assets/appeal/play.png"),
      showvideoplay:false,
      videoUrl:'',
      video:null
    }
  },
  mounted () {
    
  },
  methods:{
    asyncBeforRead(file){
      console.log(file);
     return this.filterBefore(file, this.item.upType)
    },
    filterBefore(file, upType) {
    const obj = {
      video: () => {
        const type = file.type.substring(0, file.type.indexOf("/"));
        if (upType != type) {
          this.$notify({ type: "warning", message: "请选择视频" });
          return false;
        }
        return true;
      },
      image: () => {
        const type = file.type.substring(0, file.type.indexOf("/"));
        if (upType != type) {
          this.$notify({ type: "warning", message: "请选择图片" });
          return false;
        }
        return true;
      },
    };
    return obj[upType]();
  },
    afterRead(file){
    
    file.status = "uploading";
    file.message = "上传中...";
    // file.url = file.file.path;
    this.videoUrl = file.content;
    file.status = "";
    file.message = "";
    // uploadFileOss(file.file, "default", ({ loaded, total }) => {})
    //   .then((path) => {

    //     console.log("上传成功", path);
    //     this.$emit("change", [{ url: path }]);
    //   })
    //   .finally((res) => {
    //     file.status = "";
    //     file.message = "";
    //   });
    },
  //视频播放
    showPreview(){
    if (this.item.upType && this.item.upType === "video") {
      this.showvideoplay = true;
      this.videoUrl = this.upLoader[0].url;
    }
    },
  //视频暂停
    stopVideo(){
          this.showvideoplay = false;
          this.$refs.video.pause();
    }
  }

}
</script>


<style lang="less" scoped>
  /deep/.van-uploader__upload {
    &-text {
      margin-top: 0;
    }
    &-icon {
      margin-top: 15px;
    }
  }
  //视频样式
  .preview-cover {
    height: 100%;
    // .fj(center,center);
              display: flex;
  justify-content: center;
  align-items: center;
    .coverImg {
      width: 40px;
      height: 40px;
    }
  }

  .video-warp {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 100px;
    .content {
      position: relative;
      width: 300px;
      height: 200px;
      video::-webkit-media-controls-enclosure {
        overflow: hidden;
      }
      video::-webkit-media-controls-panel {
        width: calc(100% + 30px);
      }
      .close {
        position: absolute;
        // background-image: require("@/assets/appeal/play.png");
        // background-repeat: no-repeat;
        // background-size: 100% 100%;
          display: flex;
  justify-content: center;
  align-items: center;
        width: 32px;
        height: 32px;
        text-align: center;
        left: 50%;
        transform: translate(-50%);
        color: #fff;
      }
    }
  }
</style>
